module.exports = __webpack_public_path__ + "static/img/warm_animate1.e959021a.png";